var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-bandaid"}},[_c('div',{attrs:{"id":"bandaid"}},[_c('a',{staticClass:"bandaid-sign-plus",attrs:{"href":"#"},on:{"click":_vm.click}},[_vm._v("+")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61375ec4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/BandAidForAdditionals.vue
// module id = 481
// module chunks = 0